import './preview.scss';

import { number, oneOf, string } from 'prop-types';
import React from 'react';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';

import { mediaTypesShape } from '../../prop-types';
import Image from '../Image';
import { MEDIA_TYPES } from '../Thumbnail/constants';

function Preview({ src, width, target, trigger, type }) {
  const commonProps = {
    alt: '',
    src,
    style: { maxWidth: width },
  };
  return (
    <Tooltip
      placement="right"
      innerClassName="preview-inner"
      fade={false}
      target={target}
      trigger={trigger}
      modifiers={{
        preventOverflow: { enabled: false },
        hide: { enabled: false },
        flip: { enabled: false },
      }}
      boundariesElement="window"
    >
      {type === MEDIA_TYPES.VIDEO ? (
        <video muted autoPlay {...commonProps} />
      ) : (
        <Image {...commonProps} />
      )}
    </Tooltip>
  );
}

Preview.propTypes = {
  src: string.isRequired,
  target: string.isRequired,
  trigger: oneOf(['click', 'hover', 'legacy']),
  width: number,
  type: mediaTypesShape.isRequired,
};

Preview.defaultProps = {
  trigger: 'hover',
  width: 300, // px
};

export default Preview;
